<app-action-button
  (addEvent)="create($event)"
  (deleteEvent)="openConfirm($event)"
  [hidden]="(!isDeleteAction && !authorizationService.canCreateCAs()) || (isDeleteAction && selectedCAIds.length > 1)"
  [isDeleteAction]="isDeleteAction"
></app-action-button>

<app-loader [isLoading]="isLoading" id="gatewaysPage"></app-loader>

<div class="area" id="ItemsArea">
  <app-noitems
    (clickEmit)="create(true)"
    [image]="'CAs'"
    [isEmpty]="!isLoading && items.length === 0"
    [typeName]="'Certificate Authorities'"
    >
  </app-noitems>

  <div [hidden]="!showList || isLoading" id="ItemTable">
    <div class="tableGrid tHeadRow">
      <div class="tHead">
        @if (hasSomeDeletePermission) {
          <div
            (click)="toggleAll()"
            [ngClass]="{ selected: allToggled }"
            class="tSelect all"
            id="ToggleAll"
          ></div>
        }
      </div>
      <div (click)="sort('name')" [ngClass]="getSortClass('name')" class="tHead sort">Name</div>
      <div
        (click)="sort('isAutoCaEnrollmentEnabled')"
        [ngClass]="getSortClass('isAutoCaEnrollmentEnabled')"
        class="tHead desktop sort"
        >
        Auto Enrollment
      </div>
      <div
        (click)="sort('isOttCaEnrollmentEnabled')"
        [ngClass]="getSortClass('isOttCaEnrollmentEnabled')"
        class="tHead desktop sort"
        >
        OTT Enrollment
      </div>
      <div (click)="sort('isAuthEnabled')" [ngClass]="getSortClass('isAuthEnabled')" class="tHead desktop sort">
        Auth Enabled
      </div>
      <div (click)="sort('isVerified')" [ngClass]="getSortClass('isVerified')" class="tHead desktop sort">
        Verified
      </div>
      <div
        (click)="sort('verificationToken')"
        [ngClass]="getSortClass('verificationToken')"
        class="tHead desktop sort"
        >
        Verification Token
      </div>
      <div class="thead tRight">
        @if (anyToggled()) {
          <div (click)="toggleMenu($event, -2)" class="dots" id="Dots_Bulk">
            ...
            <div (clickOutside)="closeActionMenu()" [ngClass]="{ open: -2 === openIndex }" class="tMenu">
              <div (click)="downloadCsv($event)" class="tActionRow" id="DownloadCSV_Bulk">Download CSV</div>
            </div>
          </div>
        }
      </div>
    </div>
    <div id="ItemsList">
      @for (
        item of displayedItems
        | sortby: sorting:ordering:'true'
        | paginate
        : {
        itemsPerPage: pageSize,
        currentPage: page,
        totalItems: totalElements
        }; track trackById(index,
        item); let index = $index) {
        <div
          [attr.data-index]="index"
          class="tableGrid tRow t{{ item.status }}"
          id="Item_{{ item.id }}"
          >
          <div class="tCol">
            @if (item.actionList.includes('delete')) {
              <div
                (click)="toggle(item)"
                [ngClass]="{ selected: item.selected }"
                class="tSelect"
                id="RowSelect0_{{ item.id }}"
              ></div>
            }
          </div>
          <div (click)="open(item)" class="tCol clickCol" id="RowSelect1_{{ item.id }}">
            {{ item.name }}
          </div>
          <div (click)="open(item)" class="tCol clickCol desktop" id="RowSelect2_{{ item.id }}">
            {{ item.isAutoCaEnrollmentEnabled ? 'Yes' : 'No' }}
          </div>
          <div (click)="open(item)" class="tCol clickCol desktop" id="RowSelect3_{{ item.id }}">
            {{ item.isOttCaEnrollmentEnabled ? 'Yes' : 'No' }}
          </div>
          <div (click)="open(item)" class="tCol clickCol desktop" id="RowSelect4_{{ item.id }}">
            {{ item.isAuthEnabled ? 'Yes' : 'No' }}
          </div>
          <div (click)="open(item)" class="tCol clickCol desktop" id="RowSelect5_{{ item.id }}">
            {{ item.isVerified ? 'Yes' : 'No' }}
          </div>
          <div (click)="open(item)" class="tCol clickCol desktop" id="RowSelect6_{{ item.id }}">
            {{ item.verificationToken }}
          </div>
          <div class="tCol tRight">
            @if (item.actionList.length > 0) {
              <div
                (click)="toggleMenu($event, index)"
                class="dots"
                id="RowDots_{{ index }}"
                >
                ...
                <div (clickOutside)="closeActionMenu()" [ngClass]="{ open: index === openIndex }" class="tMenu">
                  @if (item.actionList.includes('downloadJWT')) {
                    <div
                      (click)="downloadJWT(item)"
                      class="tActionRow"
                      id="RowDownloadJWT_{{ index }}"
                      >
                      Download JWT
                    </div>
                  }
                  @if (item.actionList.includes('verify')) {
                    <div
                      (click)="verifyCA(item)"
                      class="tActionRow"
                      id="RowVerify_{{ index }}"
                      >
                      Verify
                    </div>
                  }
                  @if (item.actionList.includes('delete')) {
                    <div
                      (click)="confirmDelete(item)"
                      class="tActionRow"
                      id="RowDelete_{{ index }}"
                      >
                      Delete
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
